<template>
  <Html>
    <NuxtLoadingIndicator :height="2" color="#006DB6" />
    <UiToastToaster />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </Html>
</template>

<script setup lang="ts">
  useSeoMeta({
    title: "Panel",
    titleTemplate: "%s - EverŞarj OMNI",
    description: "EverŞarj OMNI ile her şey tek ekranda!"
  })

  const route = useRoute()
</script>
